import { put, take, takeLatest } from 'redux-saga/effects';
import { FRAME_APP_MOUNTED } from '../../../actions/frameActions';
import { DEEPLINK_EMMA_CHAT_FAILURE, DEEPLINK_EMMA_CHAT_REQUEST, DEEPLINK_EMMA_CHAT_SUCCESS, sendChatbotInjectMessageToChatbotWebView, showChatbot } from '../actions/chatbotAction';



function* deepLinkToEmmaChatSaga(action) {
  try {
    console.log('deepLinkToEmmaChatSaga action.payload.token', action);
    const { payload } = action;

    // Payload from complex deep link (see resolveComplexDeeplink)
    const { message } = payload;

    if (message) {
      yield put(
        sendChatbotInjectMessageToChatbotWebView(
          JSON.parse(decodeURIComponent(message)),
        ),
      );
    }

    yield put(showChatbot())

    yield put({ type: DEEPLINK_EMMA_CHAT_SUCCESS });
  } catch (e) {
    yield put({ type: DEEPLINK_EMMA_CHAT_FAILURE, payload: e });
  }
}

function* chatbotSaga() {
  yield take(FRAME_APP_MOUNTED);
  yield takeLatest(DEEPLINK_EMMA_CHAT_REQUEST, deepLinkToEmmaChatSaga);
}

export default chatbotSaga;
